import type { ReactNode } from "react";
import { Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";

interface ToolbarSegmentProps {
  children: ReactNode;
  className?: string;
}

export const ToolbarSegment = ({
  children,
  className,
}: ToolbarSegmentProps) => (
  <Stack
    direction="row"
    align="center"
    gap={0.5}
    className={cn("shrink-0 border-l border-line px-1", className)}
  >
    {children}
  </Stack>
);
